/**
 * Google Recaptcha
 */

// Funcion para obtener el token de Google Recaptcha
window.getGRecaptchaResponse = function (action) {
    return new Promise(function (resolve, reject) {
        if (typeof grecaptcha === "undefined" || !recaptcha_sitekey) {
            reject();
            return;
        }

        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcha_sitekey, {action: action})
                      .then(resolve)
                      .catch(reject);
        });
    });
};

// Funcion para agregar el token de Google Recaptcha a un FormData
window.appendGRecaptchaResponse = function (formData, action) {
    return getGRecaptchaResponse(action).then(function (gRecaptchaResponse) {
        formData.append("g-recaptcha-response", gRecaptchaResponse);
        return formData;
    });
};

/**
 * /Google Recaptcha
 */
